<template>
    <div>
        <Head title="Користувачі"/>
        <h1 class="mb-8 text-3xl font-bold">Користувачі</h1>
        <div class="flex items-center justify-between mb-6">
            <Link class="btn-indigo" :href="route('users.create')">
                <span>Створити</span>
                <span class="hidden md:inline">&nbsp;користувача</span>
            </Link>
        </div>
        <div class="mb-3">
            <text-input
                v-model="form.phone_number"
                type="text"
                class="w-full mt-4"
                placeholder="Пошук за номером телефону"
            />
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Ім'я</th>
                    <th class="pb-4 pt-6 px-6">Телефон</th>
                    <th class="pb-4 pt-6 px-6" colspan="2">Ролі</th>
                </tr>
                <tr v-for="user in users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="route('users.edit', user.id)">
                            {{ user.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
                            {{ user.phone_number }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4"
                            :href="route('users.edit', user.id)"
                            tabindex="-1"
                        >
                            <div v-if="user.owner" class="p-1 m-1 border rounded bg-green-200">Адмін</div>
                            <div v-if="user.watchman" class="p-1 m-1 border rounded fa-solid bg-indigo-300">Сторож</div>
                            <div class="border rounded p-1 m-1 fa-solid bg-gray-300">Користувач</div>
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link class="flex items-center px-4" :href="route('users.edit', user.id)" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="users.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">No users found.</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import {route} from "ziggy-js";
import TextInput from "@/Shared/TextInput.vue";

export default {
    components: {
        TextInput,
        Head,
        Icon,
        Link,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        users: Array,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                role: this.filters.role,
                trashed: this.filters.trashed,
                phone_number: this.filters.phone_number || '',
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/admin/users', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        route,
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
